var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  CHECKLIST\n  "),_vm._l((_vm.sereneCards),function(aCard,i){return _c('serene-cards',{key:i,attrs:{"card":aCard}},[_vm._v("\n    "+_vm._s(aCard)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }